import React, { useState } from "react";
import { TextField, Button, Box, Grid, Card, IconButton, Stack, Typography } from "@mui/material";
import fetchData from "verticales/FetchData";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CloseIcon from "@mui/icons-material/Close";
import AppLoading from "verticales/AppLoading.tsx";

const Formulario = (props: any) => {
  const [formData, setFormData] = useState({ nit: "", razonSocial: "" });
  const [blocking, setBlocking] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    setBlocking(true);
    e.preventDefault();
    const apiUrl = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
    const action = "backup-creator";
    const params = {
      action: "create-client",
      object: {
        nit: formData.nit,
        razon_social: formData.razonSocial,
      },
    };

    console.log(params);

    try {
      const response = await fetchData(apiUrl, action, params);
      console.log("Respuesta del API:", response);
    } catch (error) {
      setErrorMessage("Error en creacion.....");
      console.error("Error al enviar los datos:", error);
    }
    setBlocking(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={3}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h5" color="white">
                  Crear Cliente
                </MDTypography>
                <IconButton onClick={props.handleCloseModal} color="inherit">
                  <CloseIcon />
                </IconButton>
              </MDBox>
              {blocking ? (
                <AppLoading titleCustom={"Creando cliente....."} />
              ) : (
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    p: 3,
                    backgroundColor: "white",
                  }}
                >
                  <TextField
                    fullWidth
                    label="NIT"
                    name="nit"
                    variant="outlined"
                    value={formData.nit}
                    onChange={handleChange}
                  />

                  <TextField
                    fullWidth
                    label="Razón Social"
                    name="razonSocial"
                    variant="outlined"
                    value={formData.razonSocial}
                    onChange={handleChange}
                  />

                  {errorMessage && (
                    <Typography color="error" variant="body2">
                      {errorMessage}
                    </Typography>
                  )}
                  <Stack justifyContent="right" direction="row" sx={{ p: 1 }}>
                    {errorMessage && (
                      <Typography color="error" variant="body2" sx={{ ml: 2 }}>
                        {errorMessage}
                      </Typography>
                    )}
                    <MDButton disableElevation onClick={handleSubmit}>
                      <MDTypography>Aceptar</MDTypography>
                    </MDButton>
                    <MDButton disableElevation onClick={props.handleCloseModal}>
                      <MDTypography>Cancelar</MDTypography>
                    </MDButton>
                  </Stack>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default Formulario;
